// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// Utils
import { signed } from "./formatters";

export type AxisSummaryValueType = {
  direction: string | null;
  prismDioptres: number | null;
  significant: boolean;
};

type AxisSummaryType = {
  axis: AxisSummaryValueType;
  pattern?: string | null;
};

const AxisSummary = ({ axis, pattern }: AxisSummaryType) => {
  const { t } = useTranslation();
  return (
    <Box display="flex" flexDirection="column">
      <Box display="inline-flex" flexWrap="wrap" alignItems="center" gap="4px">
        <Typography fontSize="12px">{signed(axis.prismDioptres)}Δ</Typography>
        {" | "}
        <Typography fontSize="12px">
          {t(
            axis.direction && axis.direction !== "None" ? axis.direction : "N/A"
          )}
        </Typography>
      </Box>

      <Box display="inline-flex" flexWrap="wrap" alignItems="center" gap="4px">
        {axis.significant ? (
          <Typography fontSize="12px">{t("Significant")}</Typography>
        ) : (
          <Typography fontSize="12px">{t("Below Threshold")}</Typography>
        )}
        {pattern !== undefined && " | "}
        {pattern !== undefined && (
          <Typography fontSize="12px">
            {t(pattern && pattern !== "None" ? pattern : "N/A")}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default AxisSummary;
